import { useGetPatientQuery } from '@/core/services/patient'

export function useGetPatientInfo({ patientId }: { patientId: string }) {
  const { data: patient, isLoading, error } = useGetPatientQuery(patientId)

  return { patient }
}
